import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%'
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2)
    },
    table: {
      minWidth: 750
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    },
    separator: {
      color: '#E0E0E0',
      display: 'flex',
      zIndex: 100,
      position: 'absolute',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    separatorRight: {
      left: '-22px'
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px'
    },
    buttonBar: {
      display: 'flex',
      flex: 3,
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    },
    tableContainer: {
      flex: 1,
      justifyContent: 'flex-end'
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
      position: 'absolute'
    }
  })
)
